import { Router } from "@reach/router";

import Posts from './components/posts'

function App() {
  return (
    <Router>
      <Posts path="/" />
      <Posts path="/posts" />
    </Router>
  );
}

export default App;